import purecloud from "./subroutes/purecloud";
/* import appfoundry from './subroutes/purecloudapp' */

import casos from "./subroutes/casos";
import contactos from "./subroutes/contactos";
import usuarios from "./subroutes/usuarios";
import grupos from "./subroutes/grupos";
import cuentas from "./subroutes/cuentas";
import configuracion from "./subroutes/configuracion";
import proyectos from "./subroutes/proyectos";
import empresas from "./subroutes/empresas";
import chequeo from "./subroutes/chequeo";
import encuestas from "./subroutes/encuestas";
import actividadesprogramadas from "./subroutes/actividadesprogramadas";
import procesos from "./subroutes/procesos";
import horarios from "./subroutes/horarios";
import horariosclientes from "./subroutes/horariosclientes";
import zonashorarias from "./subroutes/zonashorarias";
import reporteinc from "./subroutes/reporteinc";
import licencia from "./subroutes/licencia";
import company from "./subroutes/company";
import complice from "./subroutes/complice";
import pasos from "./subroutes/pasos";
import multityping from "./subroutes/multityping";
// import misreportes from './subroutes/misreportes'
// import reportedash from './subroutes/reportedash'
import misproyectos from "./subroutes/misproyectos";
import configuraciondash from "./subroutes/configuraciondash";
import templatecorreo from "./subroutes/templatecorreo";
import apexcharts from "./subroutes/apexcharts";
import menu from "./subroutes/menu";
import personalizacion from "./subroutes/personalizacion";
import gruposkill from "./subroutes/gruposkill";
import tabtest from "./subroutes/tabtest";
import dynforms from "./subroutes/dynforms";
import cargamasiva from "./subroutes/cargamasiva";
import aplicacionesexternas from "./subroutes/aplicacionesexternas";
import casoscorreos from "./subroutes/casoscorreos";
import llamadas from "./subroutes/llamadas";
import sso from "./subroutes/sso";
import segmentacion from "./subroutes/segmentacion";
import relacionusuarioinstancia from "./subroutes/relacionusuarioinstancia";
import keycloak from "./subroutes/keycloak";
import outbound from "./subroutes/outbound";
import hyperpersonalizacion from "./subroutes/hyperpersonalizacion";
import catalogodocumentos from "./subroutes/catalogodocumentos";
import gestordocumental from "./subroutes/gestordocumental";

const routes = [
  {
    path: "/purecloud/:channel/:conversationId/:contactDni",
    name: "purecloud",
    meta: { requiresAuth: true, withoutPermissions: true, purecloud: true },
    component: () => import("@/layouts/Purecloud"),
    children: [...purecloud],
  },
  // {
  //     path: '/appfoundry',
  //     name: 'appfoundry',
  //     meta: { requiresAuth: false, withoutPermissions: true, purecloud: true },
  //     component: () => import('@/layouts/Purecloud'),
  //     children: [...appfoundry]
  // },
  //
  /* {
    path: '/appfoundry',
    name: 'appfoundry',
    meta: { requiresAuth: false, withoutPermissions: true, purecloud: true },
    component: () => import('@/layouts/PurecloudAppfoundry'),
    children: [...appfoundry]
  }, */
  {
    path: "/integracionview/:plataforma/:channel/:interactionId/:busqueda",
    name: "integracionView2",
    meta: { requiresAuth: false, withoutPermissions: true },
    component: () => import("@/views/Integracion/IntegracionView"),
  },
  {
    path: "/integracionview/:plataforma/:channel/:interactionId/:busqueda/:token",
    name: "integracionView",
    meta: { requiresAuth: false, withoutPermissions: true },
    component: () => import("@/views/Integracion/IntegracionView"),
  },
  {
    path: "/loginitg",
    name: "loginitg",
    meta: { requiresAuth: false, withoutPermissions: true },
    component: () => import("@/components/Integraciones/LoginItg"),
  },
  {
    path: "/cargamasiva",
    name: "cargamasiva",
    meta: { requiresAuth: true, withoutPermissions: false },
    component: () => import("@/views/CargaMasiva/CargaMasiva"),
  },
  {
    path: "/logintoken/:token",
    name: "logintoken",
    meta: { requiresAuth: false, withoutPermissions: true },
    component: () => import("@/views/LoginToken/LoginToken"),
  },
  {
    path: "/",
    meta: {
      requiresAuth: true,
      withoutPermissions: false,
      keycloakRequired: true,
    },
    component: () => import("@/layouts/Dashboard"),
    children: [
      {
        path: "403",
        name: "403",
        meta: { withoutPermissions: true },
        component: () => import("@/views/Pages/Errors/403"),
      },
      {
        path: "",
        name: "menu",
        component: () => import("@/views/Menu/Menu"),
      },
      ...casos,
      ...contactos,
      ...usuarios,
      ...grupos,
      ...cuentas,
      ...configuracion,
      ...proyectos,
      ...empresas,
      ...chequeo,
      ...procesos,
      ...encuestas,
      ...horarios,
      ...horariosclientes,
      ...zonashorarias,
      ...actividadesprogramadas,
      ...reporteinc,
      ...licencia,
      ...company,
      ...complice,
      ...pasos,
      ...multityping,
      // ...misreportes,
      // ...reportedash,
      ...misproyectos,
      ...configuraciondash,
      ...templatecorreo,
      ...apexcharts,
      ...menu,
      ...personalizacion,
      ...gruposkill,
      ...tabtest,
      ...dynforms,
      ...aplicacionesexternas,
      ...casoscorreos,
      ...llamadas,
      ...sso,
      ...segmentacion,
      ...relacionusuarioinstancia,
      ...keycloak,
      ...outbound,
      ...hyperpersonalizacion,
      ...catalogodocumentos,
      ...gestordocumental
    ],
  },
  {
    path: "/",
    meta: { requiresAuth: false, withoutPermissions: true },
    component: () => import("@/layouts/Single"),
    children: [
      {
        path: "/login",
        name: "login",
        meta: { requiresGuest: true, keycloakRequired: true },
        component: () => import("@/views/Usuario/Login"),
      },
      {
        path: "/logoutAzure",
        name: "logoutAzure",
        meta: { requiresGuest: true },
        component: () => import("@/views/Usuario/LogoutAzure"),
      },
      {
        path: "/aprobar/:idcaso/:idchecklist/:idaprobador",
        name: "aprobar",
        meta: { withoutPermissions: false },
        component: () => import("@/views/AprobacionLanding/Landing"),
      },
      {
        path: "/recuperarpass",
        name: "recuperarpass",
        meta: { requiresGuest: true },
        component: () => import("@/views/Usuario/Recuperarpass"),
      },
      {
        path: "/encuesta/:id",
        name: "encuesta",
        meta: { requiresGuest: false },
        component: () => import("@/views/Encuestas/Encuestionario"),
      },
      {
        path: "/hyperpersonalizacion/agentform/:name",
        name: "hpagentform",
        component: () => import("@/views/Hyperpersonalizacion/BeFrameHyper"),
        props: { path: "/agentform"},
        meta: { requiresAuth: true, withoutPermissions: true }
      },
      {
        path: "/hyperpersonalizacion/agentform/:name/:number",
        name: "hpagentform",
        component: () => import("@/views/Hyperpersonalizacion/BeFrameHyper"),
        props: { path: "/agentform"},
        meta: { requiresAuth: true, withoutPermissions: true }
      },
      {
        path: "/hyperpersonalizacion/userform/:name",
        name: "hpuserform",
        component: () => import("@/views/Hyperpersonalizacion/BeFrameHyper"),
        props: { path: "/userform"},
        meta: { requiresAuth: true, withoutPermissions: true }
      },
      {
        path: "/hyperpersonalizacion/userform/:name/:number",
        name: "hpuserform",
        component: () => import("@/views/Hyperpersonalizacion/BeFrameHyper"),
        props: { path: "/userform"},
        meta: { requiresAuth: true, withoutPermissions: true }
      },
      {
        path: "*",
        name: "404",
        meta: { withoutPermissions: true },
        component: () => import("@/views/Pages/Errors/404"),
      }
    ],
  },
];

export default routes;
